var exports = {
  "Gt": "xa15a2ab7--126266--frame",
  "Hm": "xa15a2ab7--126266--village",
  "Qs": "xa15a2ab7--126266--content",
  "wm": "xa15a2ab7--126266--logo",
  "e4": "xa15a2ab7--126266--banks",
  "Wp": "xa15a2ab7--126266--header-wrapper",
  "RJ": "xa15a2ab7--126266--description-wrapper",
};

module.exports = exports;
